import { capitalize } from "@helpers/general";
import {
    PrinterRowData,
    PrinterSettingConfig,
    PRINTER_MODE_OF_SALE_PATH,
} from "@components/Common/PrinterSetting";

const SAVE_PATH = "/settings/application/pos/printer/setting";

function buildTitle(t: (key: string) => string) {
    return (rowData: PrinterRowData): string => {
        const application =
            (rowData["applicationDesignation"] as string | undefined) ?? "";
        const peripheral =
            (rowData[t("Peripheral")] as string | undefined) ?? "";
        return `${capitalize(t("Settings"))} ${application} - ${peripheral}`;
    };
}

export function buildPosPrinterSettingConfig(
    t: (key: string) => string
): PrinterSettingConfig {
    return {
        appId: "POS",
        appNameField: "applicationDesignation",
        endpoints: {
            save: `${process.env.REACT_APP_API_V2_URL}${SAVE_PATH}`,
            fetchModeOfSale: `${process.env.REACT_APP_API_V2_URL}${PRINTER_MODE_OF_SALE_PATH}`,
        },
        features: {
            confirmBeforeSave: false,
            includeUuidUser: true,
            includeOperatorId: true,
        },
        titleTemplate: buildTitle(t),
    };
}
